import React, { useState, useEffect } from "react";

interface GlobalErrorBoundaryProps {
  children: React.ReactNode;
}

export const GlobalErrorBoundary: React.FC<GlobalErrorBoundaryProps> = ({
  children,
}) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      if (
        event.error?.message?.includes("text/html") ||
        event.error?.message?.includes("Loading chunk") ||
        event.error?.message?.includes(
          "Failed to fetch dynamically imported module"
        )
      ) {
        setHasError(true);
        window.location.reload();
        console.error(event.error);
      }
    };

    const handleRejection = (event: PromiseRejectionEvent) => {
      if (
        typeof event.reason === "object" &&
        event.reason?.message &&
        (event.reason.message.includes("text/html") ||
          event.reason.message.includes("Loading chunk") ||
          event.reason.message.includes(
            "Failed to fetch dynamically imported module"
          ))
      ) {
        setHasError(true);
        window.location.reload();
        console.error(event.reason);
      }
    };

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", handleRejection);

    return () => {
      window.removeEventListener("error", handleError);
      window.removeEventListener("unhandledrejection", handleRejection);
    };
  }, []);

  if (hasError) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <div className="text-center">
          <h1 className="mb-4 text-2xl font-semibold">Something went wrong</h1>
          <p className="text-slate-500">
            The page will reload automatically...
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
